import { cx } from "../../utils";

const tones = {
  brand: {
    bg: "bg-gradient-to-br from-brand-500/10 to-brand-500/0",
    text: "text-brand-600",
    ring: "ring-brand-200/40",
  },
  emerald: {
    bg: "bg-gradient-to-br from-emerald-500/10 to-emerald-500/0",
    text: "text-emerald-600",
    ring: "ring-emerald-200/40",
  },
  violet: {
    bg: "bg-gradient-to-br from-violet-500/10 to-violet-500/0",
    text: "text-violet-600",
    ring: "ring-violet-200/40",
  },
  amber: {
    bg: "bg-gradient-to-br from-amber-500/10 to-amber-500/0",
    text: "text-amber-600",
    ring: "ring-amber-200/40",
  },
};

const Stat = ({ label, value, icon, hint, tone = "brand" }) => {
  const t = tones[tone] || tones.brand;
  return (
    <div className="group relative overflow-hidden rounded-2xl border border-ink-200/70 bg-white p-5 shadow-card transition-shadow hover:shadow-card-hover">
      <div className={cx("absolute -right-12 -top-12 h-40 w-40 rounded-full", t.bg)} />
      <div className="relative mb-2 flex items-center justify-between">
        <span className="text-[11px] font-semibold uppercase tracking-wider text-ink-500">
          {label}
        </span>
        {icon && (
          <span
            className={cx(
              "grid h-9 w-9 place-items-center rounded-xl bg-white ring-1",
              t.ring,
              t.text,
            )}
          >
            {icon}
          </span>
        )}
      </div>
      <div className="relative text-stat-xl text-ink-900">{value}</div>
      {hint && <p className="relative mt-1.5 text-xs text-ink-400">{hint}</p>}
    </div>
  );
};

export default Stat;
